import { cn, Skeleton } from '@atlas/ui-primitives'
import { ASSET_TILE_GRID } from './asset-thumb-tile'

export interface AssetGridSkeletonProps {
	/** How many tiles to stand in for — a plausible row, never the real count. */
	count?: number
	/**
	 * Names what is loading for a reader who cannot see the pulse; visually hidden. Omitted
	 * when an enclosing region already says it, so nothing is announced twice.
	 */
	label?: string
	className?: string
}

/**
 * A tile grid while its assets resolve: the same columns and the same square tiles the
 * real grid uses, so the section keeps its height and the tiles land where the skeleton
 * stood rather than pushing the page down as they arrive.
 */
export function AssetGridSkeleton({ count = 6, label, className }: AssetGridSkeletonProps) {
	return (
		<div className={cn(ASSET_TILE_GRID, className)} aria-busy="true">
			{label ? <span className="sr-only">{label}</span> : null}
			{Array.from({ length: count }, (_, i) => (
				<Skeleton key={i} className="aspect-square rounded-ds-sm" />
			))}
		</div>
	)
}
